var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.403 1.99514L19.053 6.27014C19.2776 6.38226 19.4664 6.55475 19.5984 6.76826C19.7303 6.98178 19.8002 7.22785 19.8 7.47884V8.77484C19.8 9.39584 19.296 9.89984 18.675 9.89984H18V17.0998H18.9C19.1387 17.0998 19.3676 17.1947 19.5364 17.3634C19.7052 17.5322 19.8 17.7611 19.8 17.9998C19.8 18.2385 19.7052 18.4675 19.5364 18.6362C19.3676 18.805 19.1387 18.8998 18.9 18.8998H2.7C2.4613 18.8998 2.23239 18.805 2.0636 18.6362C1.89482 18.4675 1.8 18.2385 1.8 17.9998C1.8 17.7611 1.89482 17.5322 2.0636 17.3634C2.23239 17.1947 2.4613 17.0998 2.7 17.0998H3.6V9.89984H2.925C2.304 9.89984 1.8 9.39584 1.8 8.77484V7.47884C1.8 7.00904 2.043 6.57704 2.4354 6.33224L10.1961 1.99514C10.3836 1.90136 10.5904 1.85254 10.8 1.85254C11.0096 1.85254 11.2155 1.90136 11.403 1.99514ZM15.3 9.89984H6.3V17.0998H8.1V11.6998H9.9V17.0998H11.7V11.6998H13.5V17.0998H15.3V9.89984ZM10.8 5.39984C10.5613 5.39984 10.3324 5.49466 10.1636 5.66345C9.99482 5.83223 9.9 6.06115 9.9 6.29984C9.9 6.53854 9.99482 6.76746 10.1636 6.93624C10.3324 7.10502 10.5613 7.19984 10.8 7.19984C11.0387 7.19984 11.2676 7.10502 11.4364 6.93624C11.6052 6.76746 11.7 6.53854 11.7 6.29984C11.7 6.06115 11.6052 5.83223 11.4364 5.66345C11.2676 5.49466 11.0387 5.39984 10.8 5.39984Z",
    fill: "url(#paint0_linear_1823_2784)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1823_2784",
    x1: 10.8,
    y1: 1.85254,
    x2: 10.8,
    y2: 18.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/Bank Icon.27ccdd8e4dae8dbb3ff5227ea83c1242.svg";
export { ForwardRef as ReactComponent };